import * as swcHelpers from '@swc/helpers';

var getProductMedia = (serverMedia)=>{
    const images = serverMedia.images.map((_param)=>{
        var { url , label , dimensions: { __typename  }  } = _param, dimensionsRest = swcHelpers.objectWithoutProperties(_param.dimensions, [
            "__typename"
        ]);
        return {
            url,
            label: label !== null && label !== void 0 ? label : undefined,
            dimensions: dimensionsRest
        };
    });
    return {
        images
    };
};

export { getProductMedia };
//# sourceMappingURL=get-product-media.js.map
